import Vue from 'vue';
import VueRouter from 'vue-router';

import {
  AMAZON_RETURNS_ROUTES,
  CLICK_AND_COLLECT_CORTE_INGLES_ROUTES,
  CLICK_AND_COLLECT_ROUTES,
  CROSS_TOWN_ROUTES,
  HISTORY,
  LOGIN_ROUTES,
  OTHER_ROUTES,
} from "@/constants/routes";

import Home from '@/views/pages/Home/Home.vue';
import DepositItem from '@/views/pages/openHub/DepositItem.vue';
import PickUpItem from '@/views/pages/openHub/PickUpItem.vue';
import ThankYou from '@/views/components/Orders/ThankYou.vue';
import ClickAndCollect from '@/views/pages/Orders/ClickAndCollect/ClickAndCollect.vue';
import CrossTown from "@/views/pages/Orders/CrossTown/CrossTown.vue";
import StartCrossTownDelivery from '@/views/pages/Orders/CrossTown/pages/Start.vue';
import CrossTownForm from '@/views/pages/Orders/CrossTown/pages/Form.vue';
import Summary from '@/views/pages/Orders/CrossTown/pages/Summary.vue';
import Profile from "@/views/pages/Profile.vue";
import History from "@/views/pages/History/History.vue";
import StartClickAndCollect from "@/views/pages/Orders/ClickAndCollect/pages/Start.vue";
import FormClickAndCollect from "@/views/pages/Orders/ClickAndCollect/pages/Form.vue";
import SummaryClickAndCollect from "@/views/pages/Orders/ClickAndCollect/pages/Summary.vue";
import FinishClickAndCollect from "@/views/pages/Orders/ClickAndCollect/pages/Finish.vue";
import HistoryList from "@/views/pages/History/pages/HistoryList.vue";
import AmazonReturns from "@/views/pages/Orders/AmazonReturns/AmazonReturns.vue";
import StartAmazonReturns from "@/views/pages/Orders/AmazonReturns/pages/Start.vue";
import FormAmazonReturns from "@/views/pages/Orders/AmazonReturns/pages/Form.vue";
import FormAmazonSummary from "@/views/pages/Orders/AmazonReturns/pages/Summary.vue";
import FinishAndOpen from "@/views/components/Orders/FinishAndOpen.vue";
import Orders from "@/views/pages/Orders/Orders.vue";
import CorteIngles from "@/views/pages/Orders/CorteIngles/CorteIngles.vue";
import StartCorteIngles from "@/views/pages/Orders/CorteIngles/pages/Start.vue";
import ExplanationCorteIngles from "@/views/pages/Orders/CorteIngles/pages/Explanation.vue";
import SummaryCorteIngles from "@/views/pages/Orders/CorteIngles/pages/Summary.vue";
import FinishSummaryCorteIngles from "@/views/pages/Orders/CorteIngles/pages/Finish.vue";

Vue.use(VueRouter);

const parseIntProps = (propName: string) => (route: any) => {
  const props = {...route.params};
  const propParam = parseInt(props[propName], 10);
  props[propName] = isNaN(propParam) ? 0 : propParam;
  return props;
};

const returnHistoryProps = (route: any) => {
  return {
    shipmentId: 0,
  };
};

const routes = [
  {
    path: '/',
    name: OTHER_ROUTES.HOME,
    component: Home,
  },

  {
    path: '/v/:phone/:vCode',
    name: LOGIN_ROUTES.VALIDATION,
    component: Home,
  },


  {
    path: '/login',
    name: LOGIN_ROUTES.LOGIN,
    component: Home,
  },

  {
    path: '/register',
    name: LOGIN_ROUTES.REGISTER,
    component: Home,
  },

  {
    path: '/reset/:token',
    name: LOGIN_ROUTES.RESET,
    component: Home,
  },

  {
    path: '/register-phone/:phone/:vCode',
    name: LOGIN_ROUTES.REGISTER_PHONE,
    component: Home,
  },

  {
    path: '/register-email/:email/:vCode',
    name: LOGIN_ROUTES.REGISTER_EMAIL,
    component: Home,
  },

  {
    path: '/register-email-phone/:email/:phone/:vCode',
    name: LOGIN_ROUTES.REGISTER_EMAIL_PHONE,
    component: Home,
  },

  {
    path: '/deposit-item/:asId',
    name: OTHER_ROUTES.DEPOSIT_ITEM,
    props: true,
    component: DepositItem,
  },

  {
    path: '/pick-up-item/:asId',
    name: OTHER_ROUTES.PICKUP_ITEM,
    props: true,
    component: PickUpItem,
  },

  {
    path: '/thank-you',
    name: OTHER_ROUTES.THANK_YOU,
    component: ThankYou,
  },

  {
    path: '/orders',
    component: Orders,
    children: [
      {
        path: 'click-and-collect',
        component: ClickAndCollect,
        children: [
          {
            path: '/',
            name: CLICK_AND_COLLECT_ROUTES.START,
            component: StartClickAndCollect,
          },
          {
            path: 'details',
            name: CLICK_AND_COLLECT_ROUTES.FORM,
            component: FormClickAndCollect,
          },
          {
            path: 'summary',
            name: CLICK_AND_COLLECT_ROUTES.SUMMARY,
            component: SummaryClickAndCollect,
          },
          {
            path: 'finish/:asId',
            name: CLICK_AND_COLLECT_ROUTES.FINISH,
            props: true,
            component: FinishClickAndCollect,
          },
        ],
      },

      {
        path: 'click-and-collect-corte-ingles',
        component: CorteIngles,
        children: [
          {
            path: '/',
            name: CLICK_AND_COLLECT_CORTE_INGLES_ROUTES.START,
            component: StartCorteIngles,
          },
          {
            path: 'explanation',
            name: CLICK_AND_COLLECT_CORTE_INGLES_ROUTES.EXPLANATION,
            component: ExplanationCorteIngles,
          },
          {
            path: 'details',
            name: CLICK_AND_COLLECT_CORTE_INGLES_ROUTES.FORM,
            component: SummaryCorteIngles,
          },
          {
            path: 'finish/:asId',
            name: CLICK_AND_COLLECT_CORTE_INGLES_ROUTES.FINISH,
            props: true,
            component: FinishSummaryCorteIngles,
          },
        ],
      },

      {
        path: 'amazon-return',
        component: AmazonReturns,
        children: [
          {
            path: '/',
            name: AMAZON_RETURNS_ROUTES.START,
            component: StartAmazonReturns,
          },
          {
            path: 'details',
            name: AMAZON_RETURNS_ROUTES.FORM,
            component: FormAmazonReturns,
          },
          {
            path: 'summary',
            name: AMAZON_RETURNS_ROUTES.SUMMARY,
            component: FormAmazonSummary,
          },
          {
            path: 'finish/:asId',
            name: AMAZON_RETURNS_ROUTES.FINISH,
            props: true,
            component: FinishAndOpen,
          },
        ],
      },

      {
        path: 'cross-town',
        component: CrossTown,
        children: [
          {
            path: '/',
            name: CROSS_TOWN_ROUTES.START,
            component: StartCrossTownDelivery,
          },
          {
            path: 'notes',
            name: CROSS_TOWN_ROUTES.FORM,
            component: CrossTownForm,
          },
          {
            path: 'summary',
            name: CROSS_TOWN_ROUTES.SUMMARY,
            component: Summary,
          },

          {
            path: 'finish/:asId',
            name: CROSS_TOWN_ROUTES.FINISH,
            props: true,
            component: FinishAndOpen,
          },
        ],
      },
    ],
  },

  {
    path: '/my-profile',
    name: OTHER_ROUTES.PROFILE,
    component: Profile,
  },

  // we need to reference by link, but the info for a shipment is a dialog. So we open and close it depending
  // on the props. The history list needs to have a shipmentId prop equals to 0 - "non shipment" - and the
  // shipment info needs to have the proper id. With it we can check if we already loaded the shipment or to
  // load it from the api (in the case of a direct link, we wont load all the history, just the shipment we need)
  {
    path: '/history',
    component: History,
    children: [
      {
        path: '/',
        name: HISTORY.START,
        props: returnHistoryProps,
        component: HistoryList,
      },

      {
        path: ':shipmentId',
        name: HISTORY.SHIPMENT,
        props: parseIntProps("shipmentId"),
        component: HistoryList,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
